import { render, staticRenderFns } from "./send-invoice-modal.vue?vue&type=template&id=3d130461"
import script from "./send-invoice-modal.ts?vue&type=script&lang=js&external"
export * from "./send-invoice-modal.ts?vue&type=script&lang=js&external"
import style0 from "./send-invoice-modal.vue?vue&type=style&index=0&id=3d130461&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports